"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gallery_1 = __importDefault(require("./gallery"));
class Modal {
    constructor() {
        this.modalId = null;
        this.openTrigger = document.querySelectorAll('[data-open]');
        this.closeTrigger = document.querySelectorAll('[data-close]');
        this.dialogs = document.querySelectorAll('.c-modal');
        this.galleryInstance = null;
    }
    /**
     * Enable Modal
     */
    enableModals() {
        const self = this;
        for (const trigger of this.openTrigger) {
            trigger.addEventListener('click', function (e) {
                var _a;
                self.modalId = trigger.getAttribute('data-open'); //this.dataset.open;
                const modal = document.getElementById((_a = self.modalId) !== null && _a !== void 0 ? _a : '');
                if (modal && !modal.hasAttribute('open')) { // check if the dialog is already open
                    modal.classList.add('c-modal--visible');
                    if (modal.nodeName === 'DIALOG') {
                        modal.showModal();
                    }
                }
                if (trigger.getAttribute('data-large-img')) {
                    // Gallery
                    self.galleryInstance = new gallery_1.default();
                    self.galleryInstance.enableGallery();
                    self.galleryInstance.initImage(self.modalId, trigger.getAttribute('data-large-img'));
                }
                self.lockScroll();
            });
            document.dispatchEvent(new CustomEvent('enableStyleguideModals'));
        }
        // Close
        for (const trigger of this.closeTrigger) {
            trigger.addEventListener('click', function (e) {
                var _a;
                e.stopPropagation();
                (_a = trigger.closest('dialog')) === null || _a === void 0 ? void 0 : _a.close();
                self.galleryInstance = null;
            });
        }
        for (const dialog of this.dialogs) {
            dialog.addEventListener('close', function () {
                dialog.classList.remove('c-modal--visible');
                self.unlockScroll();
            });
            dialog.addEventListener('click', (e) => this.handleClickOutside(e));
        }
    }
    handleClickOutside(e) {
        var _a, _b;
        const dialogElement = e.target;
        const clientX = (_a = e.clientX) !== null && _a !== void 0 ? _a : null;
        const clientY = (_b = e.clientY) !== null && _b !== void 0 ? _b : null;
        if (!dialogElement || !clientX || !clientY)
            return;
        if (dialogElement && this.clickIsOutsideElement(dialogElement, clientX, clientY)) {
            if (dialogElement.nodeName === 'DIALOG') {
                dialogElement.close();
            }
        }
    }
    clickIsOutsideElement(element, clientX, clientY) {
        const boundingRect = element.getBoundingClientRect();
        if (clientX < boundingRect.left)
            return true;
        if (clientX > boundingRect.right)
            return true;
        if (clientY < boundingRect.top)
            return true;
        if (clientY > boundingRect.bottom)
            return true;
        return false;
    }
    /**
     * Lock scroll
     * @returns {*}
     */
    lockScroll() {
        var _a;
        const overflowHidden = 'u-overflow--hidden';
        (_a = document.querySelector(`body`)) === null || _a === void 0 ? void 0 : _a.classList.add(overflowHidden);
    }
    /**
     * Unlock scroll
     * @returns {*}
     */
    unlockScroll() {
        var _a;
        const overflowHidden = 'u-overflow--hidden';
        (_a = document.querySelector(`body`)) === null || _a === void 0 ? void 0 : _a.classList.remove(overflowHidden);
    }
}
exports.default = Modal;
